import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import { useTranslation } from '../hooks/useTranslation';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header cartItemCount={0} onCartClick={() => {}} onOrderClick={() => {}} />
      
      <div className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="mb-8 hover:bg-gray-100"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('backToHome')}
          </Button>

          <h1 className="text-5xl font-bold text-black mb-8">{t('termsTitle')}</h1>

          <div className="space-y-8 text-gray-700">
            {/* Delivery */}
            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('tcDeliveryTitle')}</h2>
              <ul className="space-y-2 list-disc list-inside">
                <li>{t('tcDeliveryItem1')}</li>
                <li>{t('tcDeliveryItem2')}</li>
                <li>{t('tcDeliveryItem3')}</li>
                <li>{t('tcDeliveryItem4')}</li>
                <li>{t('tcDeliveryItem5')}</li>
              </ul>
            </section>

            {/* Payment */}
            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('tcPaymentTitle')}</h2>
              <ul className="space-y-2 list-disc list-inside">
                <li>{t('tcPaymentItem1')}</li>
                <li>{t('tcPaymentItem2')}</li>
              </ul>
            </section>

            {/* Return Policy */}
            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('tcReturnTitle')}</h2>
              <ul className="space-y-2 list-disc list-inside">
                <li>{t('tcReturnItem1')} <a href="tel:+37128717331" className="text-blue-600 underline">+371 28717331</a> {t('or')} <a href="mailto:ordersmikado@gmail.com" className="text-blue-600 underline">ordersmikado@gmail.com</a> {t('within24Hours')}</li>
                <li>{t('tcReturnItem2')}</li>
                <li>{t('tcReturnItem3')}</li>
              </ul>
            </section>

            {/* Contact Information */}
            <section>
              <h2 className="text-3xl font-bold text-black mb-4">{t('contactInfo')}</h2>
              <div className="space-y-2">
                <p className="font-semibold">Liepu iela 9, Liepāja, Latvija</p>
                <p><a href="tel:+37128717331" className="text-blue-600 underline">+371 28717331</a></p>
                <p><a href="mailto:ordersmikado@gmail.com" className="text-blue-600 underline">ordersmikado@gmail.com</a></p>
                <p className="font-semibold mt-4">{t('businessHours')}:</p>
                <p>{t('monday')}: <span className="text-red-600">{t('closed')}</span></p>
                <p>{t('tueThu')}: 12:00–21:00</p>
                <p>{t('friSat')}: 12:00–22:00</p>
                <p>{t('sunday')}: 12:00–21:00</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsAndConditions;
